import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import FormControl from './FormControl'
import ActionControl from './ActionControl'
import Label from './Label'
import Input from './Input'
import InputError from './InputError'
import TextArea from './TextArea'
import Button from '../Layout/Button/Button'
import Paragraph1 from '../Type/Paragraph1';
import fbTrack from '../FacebookTrack/FacebookTrack';


class ContactForm extends Component {

    constructor(props) {
        super(props);
        this.firstNameEl = React.createRef();
        this.lastNameEl = React.createRef();
        this.mobileEl = React.createRef();
        this.emailEl = React.createRef();
        this.postcodeEl = React.createRef();
        this.commentEl = React.createRef();
        this.recaptchaRef = React.createRef();

        this.formAction = props.formAction;
        this.getCar = props.getCar;
        this.formSubmittedHandler = props.formSubmittedHandler;

        this.state = {
            formSubmissionSuccessful: null,
            formError: "",
            firstNameError: "",
            lastNameError: "",
            mobileError: "",
            emailError: "",
            postcodeError: "",
            isVerified: false,
            capatchaValue: ""
        }

        this.firstNameValidation = ["firstNameError",
            { required: "Enter your first name" }];

        this.lastNameValidation = ["lastNameError",
            { required: "Enter your last name" }];

        this.mobileValidation = ["mobileError",
            {
                required: "Enter your mobile number",
                mobile: "Enter a valid mobile number"
            }];

        this.emailValidation = ["emailError",
            {
                required: "Enter your email address",
                email: "Enter a valid email address"
            }];

        this.postcodeValidation = ["postcodeError",
            {
                required: "Enter your postcode",
                postcode: "Enter a valid postcode"
            }];


        this.submitHandler = this.submitHandler.bind(this);
    }

    onChangeCaptcha = (value) => {
        if (value !== null) {
            this.setState({ isVerified: true, capatchaValue: value });
        } else {
            this.setState({ isVerified: false, capatchaValue: null, formError: "" });
        }
    }

    submitHandler = (event) => {

        event.preventDefault(); // stop form loading new page

        const firstName = this.firstNameEl.current.value;
        const lastName = this.lastNameEl.current.value;
        const mobile = this.mobileEl.current.value;
        const email = this.emailEl.current.value;
        const postcode = this.postcodeEl.current.value;

        var errors = 0;
        errors += this.validate(firstName, this.firstNameValidation);
        errors += this.validate(lastName, this.lastNameValidation);
        errors += this.validate(mobile, this.mobileValidation);
        errors += this.validate(email, this.emailValidation);
        errors += this.validate(postcode, this.postcodeValidation);

        // if contact form is part of car enquiry with car selector
        let carDetails = {};
        if (this.formAction === "car-enquiry") {
            carDetails = this.getCar(); // get cars from parent component
            if (!carDetails) errors += 1;
        }

        if (errors !== 0) return errors;

        if (!this.state.isVerified) return; // reCaptacha


        if (this.formAction === "car-enquiry") {
            trackCustomEvent({
                category: "Conversion",
                action: "Form Submission",
                label: "Enquiry Form"
            });

            fbTrack('track',
                'Lead',
                {
                    content_category: "Enquiry Form",
                    content_name: "Component",
                    currency: 'AUD',
                    value: 1.00
                }
            );

        }

        if (this.formAction === "contact") {
            trackCustomEvent({
                category: "Conversion",
                action: "Form Submission",
                label: "Contact Form"
            });

            fbTrack('track',
                'Lead',
                {
                    content_category: "Contact Form",
                    content_name: "Component",
                    currency: 'AUD',
                    value: 1.00
                }
            );

        }


        let formBody = {
            firstName: firstName,
            lastName: lastName,
            mobile: mobile,
            email: email,
            postcode: postcode,
            comment: this.commentEl.current.value
        }

        if (this.formAction === "car-enquiry") {
            formBody = {
                ...formBody,
                car: carDetails[1],
                estimatedValue: "",
                mileage: carDetails[0]["vehicleMileage"],
                colour: carDetails[0]["vehicleColour"]
            };
        }



        this.setState({ formSubmissionSuccessful: true });

        var apiPath = "website/contact";
        if (this.formAction === "car-enquiry") {
            apiPath = "website/enquiry";
            this.formSubmittedHandler();
        }
        fetch(`https://carxapi.com/${apiPath}`, {
            //fetch(`http://172.16.16.210:8081/${apiPath}`, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(formBody),
            headers: {
                'Capatcha': this.state.capatchaValue,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.status !== 200 && res.status !== 201) {
                this.setState({ formError: "Unfortunately we were unable to send your enquiry." })
                window.grecaptcha.reset();

                throw new Error('Failed!');
            }
            return res.json();
        })
            .then(resData => {
                // bit too long to wait actual emails sent 
                this.setState({ formSubmissionSuccessful: true });

                //navigate("/contact-confirmation/");

            })
            .catch(err => {
                console.log(err);
            });

    };

    validate = (value, validation) => {
        var fieldValue = value;
        var errMessage = "";

        if ('email' in validation[1]) {
            let emailValid = fieldValue.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
            if (!emailValid) {
                errMessage = validation[1].email;
            }
        }
        if ('postcode' in validation[1]) {
            var rePostcode = new RegExp("^(0[289][0-9]{2})|([123456789][0-9]{3})$");
            if (!rePostcode.test(fieldValue)) {
                errMessage = validation[1].postcode;
            }
        }
        if ('mobile' in validation[1]) {
            var reMobile = new RegExp("^((61|\\+61)?\\s?)((04[0-9]{2}|4[0-9]{2})\\s?)([0-9]{3}\\s?[0-9]{3}|[0-9]{2}\\s?[0-9]{2}\\s?[0-9]{2})$");
            if (!reMobile.test(fieldValue)) {
                errMessage = validation[1].mobile;
            }
        }
        if ('required' in validation[1]) {
            if (fieldValue.trim().length === 0) {
                errMessage = validation[1].required;
            }
        }

        this.setState({ [validation[0]]: errMessage });
        return (errMessage === "") ? 0 : 1;
    }

    render() {

        const confirmationMessage = (
            <>
                <Paragraph1>
                    <strong>All Done!</strong>
                </Paragraph1>
                <Paragraph1>
                    Thank you for your enquiry. One of our car sales consultants will be in contact shortly.
                </Paragraph1>
                <Paragraph1>
                    You should also receive a confirmation email. Please check your spam or junk mail folder.
                </Paragraph1>
                <Paragraph1>
                    And you can always email us at:<br />
                    hello@summon.com.au
                </Paragraph1>
            </>
        )

        const pageHTML = (

            <form onSubmit={this.submitHandler}>
                <FormControl>
                    <Label>First Name</Label>
                    <Input
                        type="text"
                        id="firstName"
                        onBlur={(e) => this.validate(e.target.value, this.firstNameValidation)}
                        ref={this.firstNameEl}
                    />
                    <InputError>{this.state.firstNameError}</InputError>
                </FormControl>

                <FormControl>
                    <Label>Last Name</Label>
                    <Input
                        type="text"
                        id="lastName"
                        onBlur={(e) => this.validate(e.target.value, this.lastNameValidation)}
                        ref={this.lastNameEl}
                    />
                    <InputError>{this.state.lastNameError}</InputError>
                </FormControl>

                <FormControl>
                    <Label >Mobile</Label>
                    <Input
                        type="text"
                        id="mobile"
                        onBlur={(e) => this.validate(e.target.value, this.mobileValidation)}
                        ref={this.mobileEl} />
                    <InputError>{this.state.mobileError}</InputError>
                </FormControl>

                <FormControl>
                    <Label>Email</Label>
                    <Input
                        type="email"
                        id="email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$"
                        onBlur={(e) => this.validate(e.target.value, this.emailValidation)}
                        ref={this.emailEl} />
                    <InputError>{this.state.emailError}</InputError>
                </FormControl>

                <FormControl>
                    <Label>Postcode</Label>
                    <Input
                        type="text"
                        id="postcode"
                        onBlur={(e) => this.validate(e.target.value, this.postcodeValidation)}
                        ref={this.postcodeEl}
                    />
                    <InputError>{this.state.postcodeError}</InputError>
                </FormControl>

                <FormControl>
                    <Label>Comment</Label>
                    <TextArea
                        rows="8"
                        cols="40"
                        id="comment"
                        ref={this.commentEl} />
                </FormControl>

                <div>
                    <ReCAPTCHA
                        ref={this.recaptchaRef}
                        sitekey="6LcJvbYUAAAAAIMoSZgsxjjb69wAQ9OhaIoND4nC"
                        onChange={this.onChangeCaptcha}
                        theme="light"
                        size="normal"
                    />
                </div>

                <ActionControl>
                    <Button type="submit">Submit</Button>
                    <InputError>{this.state.FormError}</InputError>
                </ActionControl>

            </form>
        )

        return (

            <>
                {this.state.formSubmissionSuccessful && confirmationMessage}
                {!this.state.formSubmissionSuccessful && pageHTML}
            </>

        );
    }

}

export default ContactForm;




